// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AkcijeINovostiPage_wrapper__pviPp {
  padding: 80px 130px;
  overflow-x: hidden;
}

.AkcijeINovostiPage_h1__EZCEq,
.AkcijeINovostiPage_h3__ijqtm {
  font-family: "Lato";
  font-weight: 800;
  color: #090446;
}

.AkcijeINovostiPage_h3__ijqtm {
  font-size: 24px;
}

.AkcijeINovostiPage_h1__EZCEq {
  font-size: 36px;
}

.AkcijeINovostiPage_items__WzbHx {
  height: 250px;
}

.AkcijeINovostiPage_akcije__O-Pp6,
.AkcijeINovostiPage_novosti__0txqt {
  display: flex;
  flex-direction: column;
  width: 50%;
}

.AkcijeINovostiPage_popusti__ihCKC,
.AkcijeINovostiPage_novo__o22RT {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.AkcijeINovostiPage_container__XqT-q {
  display: flex;
}

.AkcijeINovostiPage_hidden__IXHT3 {
  position: absolute;
  visibility: hidden;
  top: 0;
  left: 0;
}
.AkcijeINovostiPage_btns__1-OfX {
  display: flex;
}

.AkcijeINovostiPage_inactive__RPHus,
.AkcijeINovostiPage_btn__ChZRJ {
  font-size: 24px;
  font-family: "Lato";
  border: none;
  background: none;
  margin-bottom: 50px;
  width: 230px;
  text-align: left;
  padding-left: 25px;
}

.AkcijeINovostiPage_btn__ChZRJ {
  border-bottom: #090446 solid 2px;
  color: #090446;
  font-weight: 800;
  transition: 1s ease;
}
.AkcijeINovostiPage_inactive__RPHus {
  border-bottom: #bcbcbc solid 2px;
  color: #bcbcbc;
  font-weight: 600;
}

@media screen and (max-width: 1280px) {
  .AkcijeINovostiPage_container__XqT-q {
    display: block;
  }
  .AkcijeINovostiPage_akcije__O-Pp6,
  .AkcijeINovostiPage_novosti__0txqt {
    width: 80%;
  }
}

@media screen and (max-width: 900px) {
  .AkcijeINovostiPage_akcije__O-Pp6,
  .AkcijeINovostiPage_novosti__0txqt {
    width: 95%;
  }
}

@media screen and (max-width: 730px) {
  .AkcijeINovostiPage_wrapper__pviPp {
    padding: 40px 50px;
  }
  .AkcijeINovostiPage_popusti__ihCKC,
  .AkcijeINovostiPage_novo__o22RT {
    gap: 0px;
  }
}

@media screen and (max-width: 410px) {
  .AkcijeINovostiPage_wrapper__pviPp {
    padding-left: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/AkcijeINovostiPage/AkcijeINovostiPage.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;EAChB;EACA;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;;IAEE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".wrapper {\n  padding: 80px 130px;\n  overflow-x: hidden;\n}\n\n.h1,\n.h3 {\n  font-family: \"Lato\";\n  font-weight: 800;\n  color: #090446;\n}\n\n.h3 {\n  font-size: 24px;\n}\n\n.h1 {\n  font-size: 36px;\n}\n\n.items {\n  height: 250px;\n}\n\n.akcije,\n.novosti {\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n}\n\n.popusti,\n.novo {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.container {\n  display: flex;\n}\n\n.hidden {\n  position: absolute;\n  visibility: hidden;\n  top: 0;\n  left: 0;\n}\n.btns {\n  display: flex;\n}\n\n.inactive,\n.btn {\n  font-size: 24px;\n  font-family: \"Lato\";\n  border: none;\n  background: none;\n  margin-bottom: 50px;\n  width: 230px;\n  text-align: left;\n  padding-left: 25px;\n}\n\n.btn {\n  border-bottom: #090446 solid 2px;\n  color: #090446;\n  font-weight: 800;\n  transition: 1s ease;\n}\n.inactive {\n  border-bottom: #bcbcbc solid 2px;\n  color: #bcbcbc;\n  font-weight: 600;\n}\n\n@media screen and (max-width: 1280px) {\n  .container {\n    display: block;\n  }\n  .akcije,\n  .novosti {\n    width: 80%;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .akcije,\n  .novosti {\n    width: 95%;\n  }\n}\n\n@media screen and (max-width: 730px) {\n  .wrapper {\n    padding: 40px 50px;\n  }\n  .popusti,\n  .novo {\n    gap: 0px;\n  }\n}\n\n@media screen and (max-width: 410px) {\n  .wrapper {\n    padding-left: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `AkcijeINovostiPage_wrapper__pviPp`,
	"h1": `AkcijeINovostiPage_h1__EZCEq`,
	"h3": `AkcijeINovostiPage_h3__ijqtm`,
	"items": `AkcijeINovostiPage_items__WzbHx`,
	"akcije": `AkcijeINovostiPage_akcije__O-Pp6`,
	"novosti": `AkcijeINovostiPage_novosti__0txqt`,
	"popusti": `AkcijeINovostiPage_popusti__ihCKC`,
	"novo": `AkcijeINovostiPage_novo__o22RT`,
	"container": `AkcijeINovostiPage_container__XqT-q`,
	"hidden": `AkcijeINovostiPage_hidden__IXHT3`,
	"btns": `AkcijeINovostiPage_btns__1-OfX`,
	"inactive": `AkcijeINovostiPage_inactive__RPHus`,
	"btn": `AkcijeINovostiPage_btn__ChZRJ`
};
export default ___CSS_LOADER_EXPORT___;
